var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"challenge-post",class:{ 'post-image': !_vm.post.isText}},[_c('Post_Section_Content',{attrs:{"post":_vm.post}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }